const PLBStatus = {
  NotOnboarded: "not-onboarded",
  Active: "active",
  Deactivated: "deactivated",
};

export default PLBStatus;
